import React from 'react';
import useEventDetails from '../../hooks/ui/useEventDetails';

// Hooks
import useRichText from "../../hooks/api/useRichText";

function EventDetails() {
  const { parseBodyText } = useRichText();

  const { image, titleEvent, descriptionEvent, resourceLinks } = useEventDetails();
  return (
    <section className={'pb-14 xs:pb-20 lg:pb-28 pt-44 xs:pt-48 sm:pt-72 lg:pt-48 px-5 ls:px-9 md:px-10 xl:px-24'}>

      <h6 className={'relative pb-4 sm:pb-6 lg:pb-7 text-6xl sm:text-8xl lg:text-9xlg font-comp font-bold uppercase leading-none'}>
        Events
        <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5 bg-black'}></span>
      </h6>

      <div className={'flex flex-wrap lg:flex-nowrap justify-between mt-14 sm:mt-68px lg:mt-48'}>
        <div className='w-full lg:max-w-30 mx-h-full lg:max-h-26'>
          <img className={'w-full h-full object-cover object-center'} src={image} alt={'title'} />
        </div>
        <div className='w-full lg:max-w-37 xl:max-w-39 mt-12 sm:mt-68px lg:mt-0 ml-0 lg:ml-14'>
          <h6 className='text-32px text-base-color font-comp leading-none'>
            {titleEvent}
          </h6>
          <div className={'text-base xs:text-21px sd:text-28px lg:text-21px text-base-color font-sans leading-tight lg:leading-relaxed mt-8 lg:mt-12'}>
            {parseBodyText(descriptionEvent)}
          </div>
          <div className='event-links mt-12 ls:mt-68px lg:mt-12 text-base-color text-base xs:text-21px sd:text-28px lg:text-lg'>
            {parseBodyText(resourceLinks)}
          </div>
        </div>
      </div>

    </section>
  );
}

export default EventDetails;
